/**
 * Created by AlexanderC on 6/15/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConsoleDriver = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AbstractDriver2 = require('./AbstractDriver');

var _Log = require('../Log');

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Console native logging
 */
let ConsoleDriver = exports.ConsoleDriver = function (_AbstractDriver) {
  _inherits(ConsoleDriver, _AbstractDriver);

  function ConsoleDriver() {
    _classCallCheck(this, ConsoleDriver);

    var _this = _possibleConstructorReturn(this, (ConsoleDriver.__proto__ || Object.getPrototypeOf(ConsoleDriver)).call(this));

    _this._console = ConsoleDriver._buildConsole();
    return _this;
  }

  /**
   * @returns {Object}
   * @private
   */


  _createClass(ConsoleDriver, [{
    key: 'log',


    /**
     * @param {String} msg
     * @param {String} level
     * @param {*} context
     */
    value: function log(msg, level, context) {
      let nativeMethod = 'log';

      switch (level) {
        case _Log.Log.EMERGENCY:
        case _Log.Log.ERROR:
        case _Log.Log.CRITICAL:
          nativeMethod = 'error';
          break;
        case _Log.Log.ALERT:
        case _Log.Log.WARNING:
          nativeMethod = 'warn';
          break;
        case _Log.Log.NOTICE:
          nativeMethod = 'log';
          break;
        case _Log.Log.INFO:
          nativeMethod = 'info';
          break;
        case _Log.Log.DEBUG:
          nativeMethod = 'debug';
          break;
      }

      // Fixes issue with node env
      let logMethod = this._console[nativeMethod] || this._console.log;
      logMethod.call(ConsoleDriver.nativeConsole, _AbstractDriver2.AbstractDriver.timeString, msg);

      // @todo: figure out a better way of dumping context
      if (context) {

        // Fixes issue with node env
        let debugMethod = this._console.debug || this._console.log;
        debugMethod.call(ConsoleDriver.nativeConsole, '[DEBUG]', context);
      }
    }

    /**
     * @param {Boolean} logTime
     * @param {Boolean} coloredOutput
     * @param {Boolean} turnOff
     * @returns {ConsoleDriver}
     */

  }, {
    key: 'overrideNative',
    value: function overrideNative() {
      let logTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      var _this2 = this;

      let coloredOutput = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      let turnOff = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      let nativeConsole = ConsoleDriver.nativeConsole;

      for (let i in ConsoleDriver.METHODS_TO_OVERRIDE) {
        if (!ConsoleDriver.METHODS_TO_OVERRIDE.hasOwnProperty(i)) {
          continue;
        }

        let method = ConsoleDriver.METHODS_TO_OVERRIDE[i];

        if (!ConsoleDriver._isLogLevelEnabled(method)) {
          nativeConsole[method] = () => {};
          continue;
        }

        // Fixes issue with node env
        this._console[method] = this._console[method] || this._console.log;

        nativeConsole[method] = function () {
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          if (!turnOff) {
            var _console;

            let nativeArgs = args;

            if (coloredOutput) {
              nativeArgs = ConsoleDriver._colorOutput(method, nativeArgs);
            }

            if (logTime) {
              nativeArgs.unshift(_AbstractDriver2.AbstractDriver.timeString);
            }

            (_console = _this2._console)[method].apply(_console, _toConsumableArray(nativeArgs));
          }
        };
      }

      return this;
    }

    /**
     * @param {String} method
     * @returns {Boolean}
     */

  }], [{
    key: '_buildConsole',
    value: function _buildConsole() {
      let nativeConsole = ConsoleDriver.nativeConsole;
      let console = {};

      for (let i in ConsoleDriver.METHODS_TO_OVERRIDE) {
        if (!ConsoleDriver.METHODS_TO_OVERRIDE.hasOwnProperty(i)) {
          continue;
        }

        let method = ConsoleDriver.METHODS_TO_OVERRIDE[i];

        // Fixes issue with node env
        if (method === 'debug' && typeof nativeConsole[method] === 'undefined') {
          method = 'log';
        }

        console[method] = nativeConsole[method];

        console[method].bind(nativeConsole);
      }

      return console;
    }
  }, {
    key: '_isLogLevelEnabled',
    value: function _isLogLevelEnabled(method) {
      return ConsoleDriver.ERROR_LEVELS_MAPPING[ConsoleDriver.ENV_LOG_LEVEL].indexOf(method) !== -1;
    }

    /**
     * @returns {Object}
     */

  }, {
    key: '_colorOutput',


    /**
     * @param {String} type
     * @param {Array} args
     * @returns {Array}
     * @private
     */
    value: function _colorOutput(type, args) {
      let color = null;

      switch (type.toLowerCase()) {
        case 'error':
          color = 31; // red
          break;
        case 'warn':
          color = 33; // yellow
          break;
        default:
          color = 32; // green
      }

      args.unshift(`\x1b[${color}m`);
      args.push('\x1b[0m');

      return args;
    }

    /**
     * @example `export DEEP_LOG_LEVEL=error|warn|debug|info|silent`
     * @returns {String}
     */

  }, {
    key: 'ERROR_LEVELS_MAPPING',
    get: function get() {
      return {
        silent: ['log'],
        error: ['error', 'log'],
        warn: ['warn', 'log', 'error'],
        info: ['warn', 'log', 'error', 'info'],
        debug: ['debug', 'warn', 'log', 'info', 'error']
      };
    }
  }, {
    key: 'ENV_LOG_LEVEL',
    get: function get() {
      let envLevel = typeof window === 'undefined' ? process.env.DEEP_LOG_LEVEL : window.DEEP_LOG_LEVEL;

      envLevel = envLevel || 'info';
      envLevel = envLevel === 'undefined' ? 'info' : envLevel; // o_O

      return envLevel.toLowerCase();
    }

    /**
     * @returns {Object}
     */

  }, {
    key: 'nativeConsole',
    get: function get() {
      return typeof window === 'undefined' ? console : window.console;
    }

    /**
     * @returns {String[]}
     */

  }, {
    key: 'METHODS_TO_OVERRIDE',
    get: function get() {
      return ['error', 'log', 'warn', 'info', 'debug'];
    }
  }]);

  return ConsoleDriver;
}(_AbstractDriver2.AbstractDriver);


//////////////////
// WEBPACK FOOTER
// ../~/deep-log/lib.compiled/Driver/ConsoleDriver.js
// module id = 397
// module chunks = 0